// ----------------------------------------------------------------------------------
// Copyright (c) Microsoft Corporation. All rights reserved.
// ----------------------------------------------------------------------------------

/* eslint-disable max-len */
export const shellStringResources = {
    preserveScaleFromSchema: 'Preserve scale from schema',
    SynapseNotebooks: 'Synapse notebooks',
    SynapseScopeJobDefinition: 'SCOPE job definition',
    SynapseScopeJobDefinitions: 'Synapse SCOPE job definitions',
    SynapseSparkJobDefinition: 'Spark job definition',
    SynapseSparkJobDefinitions: 'Synapse Spark job definitions',
    SynapseSqlScript: 'SQL script',
    SynapseSqlScripts: 'Synapse SQL scripts',
    SynapseSqlPools: 'SQL Analytics pools',
    SynapseSQLDatabases: 'SQL Analytics databases',
    SynapseDatabases: 'Lake databases',
    SynapseTables: 'Synapse tables',
    TreatDecimalAsString: 'Treat decimal as string',
    SynapseRelationships: 'Synapse relationships',
    SynapseSqlPool: 'SQL Analytics pool',
    SynapseSparkPools: 'Synapse Spark pools',
    SynapseKqlScripts: 'Synapse KQL scripts',
    ServiceNow_DisplayText: 'ServiceNow',
    ModelName_UseEncryptedEndpoints: 'Use encrypted endpoints',
    ModelName_UseHostVerification: 'Use host verification',
    ModelName_UsePeerVerification: 'Use peer verification',
    ColumnNameLabel: 'Column name',
    Activities: 'Activities',
    Activity: 'Activity',
    ActivityId: 'Activity ID',
    Concurrency: 'Concurrency',
    ElapsedTimeMetric: 'Elapsed time metric',
    PageSizeLabel: 'Page size',
    ValueType: 'Value type',
    Name: 'Name',
    ServiceNowSelectLabel: 'Columns selection',
    InvalidJSONValidationMessage: '{0} has invalid JSON syntax.',
    Activity_Error_Configuration_InvalidName: 'Parameter name can\'t be empty',
    Activity_Error_Configuration_InvalidType: 'Parameter type can\'t be empty',
    Activity_Error_Configuration_InvalidValue: 'Parameter \'{0}\' value can\'t be empty',
    ParameterConfiguration_Error_DuplicateName: 'Parameters with duplicate name will be overwritten.',
    RootFolder: 'Root folder',
    RootFolder_InvalidValue: '"{0}" is not a valid value for root folder, only "Files" or "Tables" are supported.',

    ModelName_MaxConcurrentConnections: 'Max concurrent connections',
    ModelName_WriteBatchSize: 'Write batch size',
    ModelName_WriteBehavior: 'Write behavior',
    ModelName_SalesforceExternalIdFieldName: 'External ID field',
    ModelName_IgnoreNullValues: 'Ignore null values',
    SalesforceExternalIdFieldNameMissingError: 'The name of the external ID field for upsert operation is required.',
    CopySource_AdditionalColumns: 'Additional columns',
    includeDeletedObj: 'Include deleted objects',
    QueryLabel: 'Query',
    Salesforce_DisplayText: 'Salesforce',
    SalesforceServiceCloud_DisplayText: 'Salesforce Service Cloud',
    SalesforceServiceCloudObject_DisplayText: 'Salesforce Service Cloud Object',
    SalesforceServiceCloudV2Object_DisplayText: 'Salesforce Service Cloud V2 Object',
    SqlServer_DisplayText: 'SQL server',
    ModelName_Encrypt: 'Encrypt',
    ModelName_TrustServerCertificate: 'Trust server certificate',
    ModelName_HostNameInCertificate: 'Host name in certificate',
    ModelName_EnvironmentUrl: 'Environment URL',
    ModelName_ClientSecret: 'Client secret',
    ModelName_SalesforceApiVersion: 'Salesforce API version',
    ModelName_SecurityToken: 'Security token',
    Api_Version_Not_SupportDefault: '"Default" is no longer supported. Please specify an explicit API version.',
    PasswordLabel: 'Encryption password',
    SsisFilePackagePathFormatValidatorMessage: '{0} {1} has an invalid package path. The format of the package path is incorrect.',
    InvalidValue: 'Invalid value',
    DeleteLoggingSetting_EnableLabel: 'Enable logging',
    SsisActivityPackagePathLabel: 'Package path',
    Table_name_Label: 'Table name',
    LegacyName: '(Legacy)',
    WriteBehavior_Option_Insert: 'Insert',
    WriteBehavior_Option_Upsert: 'Upsert',
    WriteBehavior_Option_Upload: 'Upload',
    WriteBehavior_Option_SCD2: 'SCD2',
    MergeLabel: 'Merge',
    Update: 'Update',
    RequiresKeyColumn: '{0} requires a key column to be specified. Please specify one or more columns for row matching in \'{1}\'',
    DupKeyColumn: 'Key column \'{0}\' already listed.',

    NotebookActivityLabel: 'Notebook',
    TridentNotebookActivityNotebookIdLabel: 'Notebook id',
    TridentNotebookSessionTagLabel: 'Session tag',
    ActivityNotSupportLinkedServiceError: '{0} doesn\'t support {1}.',
    TridentWorkspaceLabel: 'Workspace',
    NotebookActivitySparkPoolLabel: 'Spark pool',
    NotebookParametersLabel: 'Notebook parameters',
    SparkJobDefinitionActivityLabel: 'Spark Job Definition',
    UserDataFunctionsLabel: 'User Data Functions',
    TridentSparkJobDefinitionActivityIdLabel: 'Spark Job Definition id',
    TridentWorkspaceIdLabel: 'Workspace id',
    SparkJobDefinitionParametersLabel: 'Spark Job Definition parameters',
    SparkJobDefinitionActivityMainDefinitionFile: 'Main definition file',
    SparkJobDefinitionActivityMainClassName: 'Main class name',
    SparkJobDefinitionActivityPythonCodeReference: 'Python code reference',
    SparkJobDefinitionActivityReferenceFiles: 'Reference files',
    SparkJobDefinitionActivitySparkPoolLabel: 'Apache Spark pool',
    SparkJobDefinitionActivityExecutorSizeLabel: 'Executor size',
    SparkJobDefinitionActivityDynamicExecutorLabel: 'Dynamically allocate executors',
    SparkJobDefinitionActivityMaxExecutorsLabel: 'Max executors',
    SparkJobDefinitionActivityMinExecutorsLabel: 'Min executors',
    SparkJobDefinitionActivityDriverSizeLabel: 'Driver size',
    SparkJobDefinitionScanFolder: 'Scan folder',
    Kql_DisplayText: 'KQL',
    FabricDataflowLabel: 'Dataflows',

    TridentSparkJobDefinitionDefaultLakehouseReferenceLabel: 'Default lakehouse reference',
    TridentSparkJobDefinitionAdditionalLakehouseReferenceLabel: 'Additional lakehouse references',
    TridentSparkJobDefinitionEnvironmentReferenceLabel: 'Environment reference',
    TridentSparkJobDefinitionLakehouseLabel: 'lakehouse',
    TridentSparkJobDefinitionAdditionalLakehouseLabel: 'additional lakehouse',
    TridentSparkJobDefinitionEnvironmentLabel: 'environment',
    TridentSparkJobDefinitionReferenceValidationError: 'Configuration issue with: {0}. Please provide valid workspace and {1} details.',
    
    File: 'File',
    ClassName: 'Class name',
    Configuration: 'Configuration',
    Configurations: 'Configurations',
    Notes: 'Notes',
    Arguments: 'Arguments',
    ScopeCustomProperties: 'SCOPE custom properties',
    ScopeReferenceAndResourceFiles: 'SCOPE reference and resource files',
    ScopeJobDefinitionJobProperties: 'SCOPE job properties',
    ScopeJobDefinitionPublishUnsupported: 'Publishing SCOPE job definition is not supported yet. Please save it first.',
    ScopeJobDefinitionTargetScopePool: 'Target SCOPE pool',
    ScopeScriptFilePath: 'SCOPE script file path',
    ScopeScriptParameters: 'SCOPE script parameters',
    RuntimeName: 'Runtime name',
    Token: 'Token',
    PrincipalId: 'Principal Id',
    StandardToken: 'Standard token',
    StandardTokenPercentage: 'Standard token percentage',
    EcoToken: ' ECO token',
    EcoTokenPercentage: 'ECO token percentage',
    DefaultTokenPolicy: 'Default token policy',
    NotificationRecipients: 'Notification recipients',
    Priority: 'Priority',
    MaxUnavailability: 'Max unavailability',
    NebulaArguments: 'Nebula arguments',
    KqlScriptPublishUnsupported: 'Publishing KQL script is not supported yet. Please save it first.',
    DatabasePublishUnsupported: 'Publishing Azure Synapse Database is not supported yet. Please save it first.',
    SparkJobDefinitionTargetSparkCompute: 'Target Spark pool',
    SparkJobDefinitionTargetSparkConfiguration: 'Target Spark configuration',
    SparkJobDefinitionRequiredSparkVersion: 'Required Spark version',
    SparkJobDefinitionJobProperties: 'Spark job properties',
    SparkJobDefinitionLanguage: 'Spark job definition language',
    SparkJobPropertiesJars: 'Jars',
    SparkJobPropertiesPyFiles: 'Python files',
    SparkJobPropertiesFiles: 'Files',
    SparkJobPropertiesArchives: 'Archives',
    SparkJobPropertiesDriverMemory: 'Driver memory',
    SparkJobPropertiesDriverCores: 'Driver cores',
    SparkJobPropertiesExecutorMemory: 'Executor memory',
    SparkJobPropertiesExecutorCores: 'Executor cores',
    SparkJobPropertiesNumExecutors: 'Number of executors',
    TridentSparkPropertiesLabel: 'Spark properties',

    LinkTable: 'Link table',
    LinkTableNameValidationError: 'A table name in a link connection mustn\'t conatin \'[\' or \']\', and its length must be between 1 - 128.',
    LinkConnection: 'Link connection',
    LinkTopicNameValidationError: 'Link connection name may only contain lowercase letters, numbers, and hyphens, and must begin with a letter or a number. Each hyphen must be preceded and followed by a non-hyphen character. The name must also be between 3 and 63 characters long.',
    CDCConnection: 'CDC Connection',
    Error_InvalidResourceReferenceTemplate: 'Failed to load the {0}. Please make sure it exists and you have the permissions to access it.',
    ConnectionLabel: 'Connection',
    DataFlowErrorAdapterNotFound: 'Adapter not found for \'{0}\'',
    ModelName_ConnectionTemplate: '{0} connection',
    ConnectionId: 'Connection ID',
    ConnectionIssues: 'Connection issues',

    SQLPoolRequired: 'SQL pool is required',
    SQLAnalyticsPoolRequired: 'Activity \'{0}\' SQL Analytics pool is required',
    SQLDatabaseRequired: 'SQL database is required',

    IntegrationRuntime: 'Integration runtime',
    IntegrationRuntimes: 'Integration runtimes',

    OnPremisesDataGateway: 'On-premises data gateway',
    OnPremisesDataGateways: 'On-premises data gateways',

    AzureTableStorage_DisplayText: 'Azure Table Storage',

    AzureBlobStorage_DisplayText: 'Azure Blob Storage',
    ModelName_ServiceEndpoint: 'Service endpoint',
    ModelName_ContainerUriName: 'Container URI',
    ModelName_StorageAccountKind: 'Storage account kind',
    FolderPath_Label: 'Folder path',
    FileNameLabel: 'File name',
    ModelName_Container: 'Container',
    CopyWizard_Dataset_Blob_Sink_ContainerValidationError: 'Container name may only contain lowercase letters, numbers, and hyphens, and must begin with a letter or a number. Each hyphen must be preceded and followed by a non-hyphen character. The name must also be between 3 and 63 characters long.',

    ModelName_AvroDataset: 'Avro',
    ModelName_DelimitedTextDataset: 'DelimitedText',
    ModelName_IcebergDataset: 'Iceberg',
    ModelName_JsonDataset: 'Json',
    ModelName_ParquetDataset: 'Parquet',
    ModelName_DelaFormatDataset: 'Delta',
    ModelName_LinkedService: 'Linked service',
    ModelName_LinkedServices: 'Linked services',
    AzureSynapseAnalytics: 'Azure Synapse Analytics',
    ModelName_Encoding: 'Encoding',
    ModelName_CompressionCodec: 'Compression codec',
    ModelName_CompressionLabel: 'Compression level',
    StoredProcedureName: 'Stored procedure name',
    StoredProcedureParameters: 'Stored procedure parameters',
    StoredProcedure: 'Stored procedure',
    ModelName_ActivityTemplate: '{0} activity',
    ModelName_ActivitiesTemplate: '{0} activities',
    ModelName_ColumnDelimiter: 'Column delimiter',
    ModelName_Template: 'Template',
    ModelName_Templates: 'Templates',
    ModelName_Source_QueryTimeout_Min: 'Query timeout (minutes)',
    ModelName_Partition_Option: 'Partition option',
    ModelName_Partition_Names: 'Partition names',
    ModelName_Partition_ColumnName: 'Partition column name',
    ModelName_Partition_UpperBound: 'Partition upper bound',
    ModelName_Partition_LowerBound: 'Partition lower bound',
    Dataset_FileFormat_RowDelimiterFieldLabel: 'Row delimiter',
    ModelName_QuoteChar: 'Quote char',
    Dataset_FileFormat_EscapeCharFieldLabel: 'Escape character',
    ModelName_CharToEscapeQuoteEscaping: 'Char to escape quote escaping',
    ModelName_FirstRowAsHeader: 'First row as header',
    NullValueFieldLabel: 'Null value',
    Dataset_FileFormat_ColumnDelimiterShouldBeNoneError: 'Column delimiter must be "No delimiter" when row delimiter is "No delimiter"',
    Dataset_FileFormat_QuoteCharShouldBeNoneError: 'Quote character should be "No quote character" when "No escape character" is set.',
    Dataset_enableVertiParquet: 'Use V-Order',
    VersionLabel: 'Version',

    Named_Keyword_ValidationError: '{0} cannot be used as a name',
    Named_StartsWithNumber_ValidationError: '{0} cannot start with a number',
    TimespanValidatorInvalidFormat: '{0} is invalid. The metric must be formatted as D.HH:MM:SS',
    TimespanValidatorBetween: '{0} cannot be \'{1}\'. It has to be between {2} and {3}.',
    TimespanValidatorMinimum: '{0} cannot be \'{1}\'. It must be a minimum value of {2}.',
    TimespanValidatorMaximum: '{0} cannot be \'{1}\'. It can have a maximum value of {2}.',
    Validator_ErrorMessage_Pattern: 'Value should be in the form of {0}',
    Validator_ErrorMessage_Number: 'Value is not a number',
    Validator_ErrorMessage_Integer: 'Value is not an Integer',
    SsisActivityRequiredParameterIsNotSet: 'Required parameter value is not set.',
    SsisProjectPathValidatorMessage: '{0} {1} has an invalid project path. It should end with file extension \'.ispac\'',
    SsisPackageNameValidatorMessage: '{0} {1} has an invalid package name. It should end with file extension \'.dtsx\'',
    SsisConfigPathValidatorMessage: '{0} {1} has an invalid configuration path. It should end with file extension \'.dtsConfig\'',
    SsisActivityDuplicateParameter: 'Parameter name cannot be duplicated.',
    SsisActivityParameterNameCannotBeEmpty: 'Parameter name cannot be emtpy.',
    SsisActivityDuplicateConnectionManager: 'Connection manager name cannot be duplicated.',
    SsisActivityDuplicateConnectionManagerProperty: 'Connection manager property name cannot be duplicated.',
    SsisActivityDuplicatePropertyOverridePath: 'Property override path cannot be duplicated.',
    SsisActivityConnectionManagerNameCannotBeEmpty: 'Connection manager name cannot be empty.',
    SsisActivityConnectionManagerPropertyCannotBeEmpty: 'Connection manager property name cannot be empty.',
    SsisActivityPropertyOverridePathCannotBeEmpty: 'Property override path cannot be empty.',

    Retry: 'Retry',
    Timeout: 'Timeout',
    ModelName_Policy: 'policy',
    ModelName_Policies: 'policies',
    SecureOutput: 'Secure output',
    SecureInput: 'Secure input',
    UserPropertiesLabel: 'User properties',
    Value: 'Value',
    NullNamesInUserPropertiesNotAllowed: 'Name is required in user properties',
    NullValuesInUserPropertiesNotAllowed: 'Value is required in user properties',
    MultipleUserPropertiesWithSameName: 'Only unique names in user properties allowed. Multiple properties named {0} were found.',
    UndefinedVariableUserProperties: 'The user property {0} contains the undefined pipeline variable {1}.',
    UserPropertyParseError: 'The user property {0} could not be parsed.',
    MaximumUserPropertiesExceeded: 'The maximum number of User Properties allowed per activity is {0}, please remove extra properties.',
    LinkCriteriaValidationMessage: 'Link from \'{0}\' to \'{1}\' activity has invalid criteria, remove and put link again.',
    Type: 'type',
    ServiceNow_UnsupportedOperator_ErrorMessage: 'Unsupported operator',

    Trigger: 'Trigger',
    Triggers: 'Triggers',
    Activated: 'Activated',
    ScheduleLabel: 'Schedule',
    ModelName_ScheduledTriggers: 'Schedule triggers',
    StartTime: 'Start time',
    EndTime: 'End time',
    Frequency: 'Frequency',
    ModelName_Interval: 'Interval',
    Timezone: 'Timezone',
    Trigger_ActivationErrorNoPipeline: 'Trigger \'{0}\' cannot be activated and contain no pipelines',
    Trigger_PipelinesLengthError: 'Trigger \'{0}\' can only contain one pipeline',
    Trigger_Dependency: 'Trigger dependency',
    ModelName_TumblingWindowTrigger: 'Tumbling window',
    ModelName_TumblingWindowTriggers: 'Tumbling window triggers',
    ModelName_Delay: 'Delay',
    Trigger_EndTimeAfterStart: 'End time cannot be before start time',
    Trigger_InvalidFrequencyError: 'Selected Frequency not supported for trigger type',
    Trigger_TumblingInvalidIntervalError: 'Tumbling Window trigger with frequency \'Minutes\' must have interval of at least 5.',
    Trigger_Interval_Hour: 'For Frequency type Hour, interval has to be in the range 1 - 12000 inclusive',
    Trigger_Interval_Minute: 'For Frequency type Minute, interval has to be in the range 1 - 720000 inclusive',
    ModelName_RerunTumblingWindowTrigger: 'Rerun tumbling window',
    ModelName_RerunTumblingWindowTriggers: 'Rerun tumbling window triggers',
    ModelName_ParentTrigger: 'Parent trigger',
    ModelName_RequestedStartTime: 'Requested start time',
    ModelName_RequestedEndTime: 'Requested end time',
    ModelName_RerunConcurrency: 'Rerun concurrency',
    Trigger_StartTimeInvalid: 'Start time is invalid',
    Trigger_EndTimeInvalid: 'End time is invalid',
    Trigger_CannotContainDuplicateRecurrenceScheduleOccurence: 'Trigger \'{0}\' cannot contain duplicate monthly occurence types',
    Trigger_Interval_Month: 'For Frequency type Month, interval has to be in the range 1 - 16 inclusive',
    Trigger_Interval_Week: 'For Frequency type Week, interval has to be in the range 1 - 71 inclusive',
    Trigger_Interval_Day: 'For Frequency type Day, interval has to be in the range 1 - 500 inclusive',

    ModelName_Command: 'Command',
    ModelName_CommandTimeout: 'Command timeout',
    ModelName_Extension: 'Extension',
    ModelName_Extensions: 'Extensions',
    ModelName_CmdKeyCommandExtension: 'Cmdkey Command Extension',
    ModelName_CmdKeyCommandExtensions: 'Cmdkey Command Extensions',
    ModelName_ComponentExtension: 'Install 3rd Party Component Extension',
    ModelName_ComponentExtensions: 'Install 3rd Party Component Extensions',
    ModelName_Content: 'Content',
    ModelName_Description: 'Description',
    ModelName_Parent: 'Parent',
    ModelName_MsdtcConfigurationExtension: 'Configure MSDTC Extension',
    ModelName_MsdtcConfigurationExtensions: 'Configure MSDTC Extensions',
    ModelName_EnvVariableExtension: 'Environment Variable Extension',
    ModelName_EnvVariableExtensions: 'Environment Variable Extensions',
    ModelName_SqlServerAliasExtension: 'SQL Server Alias Extension',
    ModelName_SqlServerAliasExtensions: 'SQL Server Alias Extensions',
    ModelName_LicensedComponentExtension: 'Install Licensed Component Extension',
    ModelName_LicensedComponentExtensions: 'Install Licensed Component Extensions',
    ModelName_AzPowerShellExtension: 'Install Azure PowerShell Extension',
    ModelName_AzPowerShellExtensions: 'Install Azure PowerShell Extensions',
    ReadBehaviorLabel: 'Read behavior',

    ModelName_ExpressCustomSetupError: 'Error of express custom setup',
    ModelName_ExpressCustomSetupErrors: 'Errors of express custom setup',

    SsisActivityLabel: 'Execute SSIS package',
    FabricSsisActivityLabel: 'Invoke SSIS package',
    ConfigurationFileLabel: 'Configuration path',
    SsisActivityProjectPathLabel: 'Project path',
    SsisActivityPackageNameLabel: 'Package name',
    SsisActivityLoggingLevelLabel: 'Logging level',
    LoggingPathLabel: 'Logging path',

    IRCreation_SSIS_CustomSetup_AzPowerShell_Format: 'Azure PowerShell {0}',
    IRCreation_SSIS_CustomSetup_CmdKey_Format: '{0},{1}',
    IRCreation_SSIS_CustomSetup_EnvrionmentVariable_Format: '{0}={1}',
    IRCreation_SSIS_CustomSetup_Msdtc: 'Configure MSDTC',
    IRCreation_SSIS_CustomSetup_MsdtcEnabled: 'Enable MSDTC',
    IRCreation_SSIS_CustomSetup_SqlServerAlias_Format: 'SqlServerAlias: {0}/{1}:{2}',
    IRCreation_SSIS_CustomSetup_Install: 'Install licensed component',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_Label: 'Component name',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_Description: 'Select the name of component to install',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_IntegrationToolkit: 'KingswaySoft\'s SSIS Integration Toolkit',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_ProductivityPack: 'KingswaySoft\'s Productivity Pack',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_TaskFactory: 'SentryOne\'s Task Factory',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_HeddaIO: 'oh22\'s HEDDA.IO',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_SQLPhoneticsNet: 'oh22\'s SQLPhonetics.NET',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_XtractIS: 'Theobald Software\'s Xtract IS',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_CDataStandard: 'CData\'s SSIS Standard Package',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_CDataExtended: 'CData\'s SSIS Extended Package',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_CDataCloud: 'CData\'s SSIS Cloud Package',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_AsIntegrationService: 'AecorSoft\'s Integration Service',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_Unknown: 'Unknown component',
    IRCreation_SSIS_CustomSetup_Install_ComponentName_Error_Duplicated: 'The component \'{0}\' already exists.',
    IRCreation_SSIS_CustomSetup_Install_ComponentLicense_Label: 'License key',
    IRCreation_SSIS_CustomSetup_Install_ComponentLicense_PlaceHolder: 'Your component license key',
    IRCreation_SSIS_CustomSetup_Install_ComponentLicense_Description: 'Enter the license key for additional component to be installed on your Azure-SSIS Integration Runtime',
    IRCreation_SSIS_CustomSetup_Install_ComponentLicenseFile_Label: 'License file',
    IRCreation_SSIS_CustomSetup_Install_ComponentLicenseFile_PlaceHolder: 'Drag & drop your license file here',
    IRCreation_SSIS_CustomSetup_Install_ComponentLicenseFile_Description: 'Upload the license file for additional component to be installed on your Azure-SSIS Integration Runtime',
    IRCreation_SSIS_CustomSetup_Install_ComponentLicenseFile_Uploaded: 'License file is uploaded, drag & drop a new one here',
    IRCreation_SSIS_CustomSetup_Install_ComponentLicenseFile_UploadMessage: 'The license file {0} is uploaded successfully at {1}',
    IRCreation_SSIS_CustomSetup_Install_ComponentLicenseFile_ErrorMessage: 'License file must be provided',
    IRCreation_SSIS_PackageStore_TYPE_AzureFileStorage: 'Azure Files',
    IRCreation_SSIS_PackageStore_Type_Unsupported: 'Unsupported Type',
    IR_ComputeNodes: 'Compute nodes',
    IR_ParallelExecutionPerNode: 'Parallel execution per node',
    UseSparkGateway: 'Use spark gateway',
    DataFlowComputeTypeLabel: 'Compute type',
    DataFlowCoreCountLabel: 'Core count',
    DataFlowCleanupLabel: 'Quick re-use',
    DataFlowSingleWord: 'Dataflow',
    ModelName_HdiOnDemand_TimeToLive: 'Time to live',
    DataIntegrationUnitLabel: 'Data integration unit',
    DataBricks_ExternalComputeInformation: 'External compute information',
    FileSystem_DisplayText: 'File system',
    ModelName_Host: 'Host',
    FileSystem_HostStartWithHttp_ErrorMessage: 'File server does not support host started with \'http:\', please consider using http linked service.',
    FileSystem_HostStartWithFtp_ErrorMessage: 'File server does not support host started with \'ftp:\', please consider using ftp linked service.',
    Error: 'Error',
    ProvisioningState: 'Provisioning state',
    PrivateEndpointPrivateIP: 'private endpoint private IP',
    PrivateEndpointResourceId: 'private endpoint resourceId',
    PrivateLinkResourceId: 'private link resourceId',
    PrivateLinkReserved: 'Reserved',
    PrivateEndpointGroupID: 'Group ID',
    PrivateEndpointConnectionState: 'connection state',
    PrivateEndpointStatus: 'status',

    RequiredTemplate: '{0} is required.',
    RequiredConnectionTemplate: '{0} {1} is required.',
    RequiredValidatorMessage: '{0} {1} requires a {2}',
    RequiredValidatorMessageNoVowel: '{0} {1} {2} is required.',
    PatternValidatorMessage: '{0} {1} cannot be \'{2}\'. It should be in the form {3}.',
    PatternValidatorListMessage: '{0} {1} cannot be \'{2}\'.\n',
    AllowedValidatorMessage: '{0} {1} cannot be \'{2}\'. It should be one of the values in [{3}].',
    WholeNumberValidatorMessage: '{0} {1} cannot be \'{2}\'. It should be a whole number.',
    MinMaxValidatorMessageBetween: '{0} {1} cannot be \'{2}\'. It has to be between {3} and {4}.',
    MinMaxValidatorMessageMinimum: '{0} {1} cannot be \'{2}\'. It has to be a minimum value of {3}.',
    MinMaxValidatorMessageMaximum: '{0} {1} cannot be \'{2}\'. It can be a maximum value of {3}.',
    OccursValidatorMessageMinOne: '{0} \'{1}\' should have at least one {2}.',
    OccursValidatorMessageMinOneSwitch: '{0} \'{1}\' should have at least one {2} for case: {3}.',
    OccursValidatorMessageMin: '{0} \'{1}\' should have at least {2} {3}.',
    OccursValidatorMessageMaxOne: '{0} \'{1}\' can have at most one {3}.',
    OccursValidatorMessageMax: '{0} \'{1}\' can have at most {2} {3}.',
    Pipelines: 'Pipelines',
    Pipeline: 'Pipeline',
    Pipeline_Policy: 'Policy',
    Pipeline_Policies: 'Policies',
    PipelineValidationMessage_Cyclic: 'Pipeline \'{0}\' cannot have cycles. Activity \'{0}\' is in a cycle.',
    Parameterization_ValidIntegerErrorMessage: 'Parameter value should be a valid integer',
    Parameterization_ValidFloatErrorMessage: 'Parameter value should be a valid float',
    Parameterization_ValidBooleanErrorMessage: 'Parameter value should be a valid boolean',
    Parameterization_ValidArrayErrorMessage: 'Parameter value should be a valid array',
    Parameterization_SecureStringWarningInGit: 'Parameters of type SecureString cannot have a default value when using Git mode, they must be fetched at runtime through Azure Key Vault or set when triggering the pipeline manually.',
    PowerBI: 'Power BI',
    MaxNumberOfActivitiesError: 'Pipeline \'{0}\' has more than the max number of {1} activities allowed per pipeline.',
    VariableLabel: 'Variable',
    VariablesLabel: 'Variables',
    LibraryVariable: 'Library variable',
    LibraryVariables: 'Library variables',
    Invalid_Variable_Integer: 'Variable value should be a valid integer',
    Invalid_Variable_Boolean: 'Variable value should be a valid boolean',
    Invalid_Variable_Array: 'Variable value should be a valid array; e.g. ["1","2","3"]',
    Variable_NotValidType: 'Variable does not have a valid type, please choose one.',
    ValidatorMessageNoneUniqueNestedNames: 'Inner activities within the same pipeline cannot have the same name. Multiple activities named {0} were found within {1}.',
    Column: 'Column',
    Columns: 'Columns',
    Database: 'Database',
    AirflowEntity: 'Airflow Entity',
    AirflowEntities: 'Airflow Entities',
    Dataset: 'Dataset',
    Datasets: 'Datasets',
    Schema: 'Schema',
    Table: 'Table',
    Role: 'Role',
    ObjectIdLabel: '{0} ID',
    UniqueValidatorMessage: 'The name \'{0}\' is duplicated in {1} {2}.',
    ModelName_LinkedServiceTemplate: '{0} linked service',
    ModelName_LinkedServicesTemplate: '{0} linked services',
    AzureKeyVault_DisplayText: 'Azure Key Vault',
    AzureStorage_DisplayText: 'Azure Storage',
    AzureSql_DisplayText: 'Azure SQL Database',
    AzureDataExplorer_DisplayText: 'Azure Data Explorer',
    LakehouseTable_DisplayText: 'Lakehouse table',
    KustoDatabase_DisplayText: 'KQL Database',
    Warehouse_DisplayText: 'Warehouse',
    Lakehouse_Fabric_DisplayText: 'Microsoft Fabric Lakehouse',
    SqlDatabase_DisplayText: 'SQL Database',
    SqlAnalyticsEndpoint_DisplayText: 'SQL Analytics Endpoint',
    FabricMaterializedLakehouseView_DisplayText: 'Fabric Materialized Lakehouse View',
    MountedRelationalDatabase_DisplayText: 'Open Mirror',
    Warehouse_Fabric_DisplayText: 'Microsoft Fabric Warehouse',
    EventStream_DisplayText: 'Eventstream',
    QueryServiceURI: 'Query service URI',
    AzureFileStorage_DisplayText: 'Azure File Storage',
    GoogleCloudStorage_DisplayText: 'Google Cloud Storage',
    SapOData_DisplayText: 'SAP OData',
    SapDatasphereForAzureDataLakeStorageGen2LinkedService_DisplayText: 'SAP Datasphere outbound for ADLS Gen2',
    SapDatasphereForGoogleCloudStorageLinkedService_DisplayText: 'SAP Datasphere outbound for Google Cloud Storage',
    SapDatasphereForAmazonS3LinkedService_DisplayText: 'SAP Datasphere outbound for Amazon S3',
    OneLakeFileLinkedService_DisplayText: 'OneLake Files',
    ModelName_Snapshot: 'Snapshot',
    Snowflake_DisplayText: 'Snowflake',
    Snowflake_Legacy_DisplayText: 'Snowflake (Legacy)',
    ModelName_AccountName: 'Account name',
    ModelName_OAuthUserName: 'OAuth user name',
    ModelName_OAuthPassword: 'OAuth password',
    ModelName_OAuthTokenEndpoint: 'OAuth endpoint',
    ModelName_PrivateKey: 'Private key',
    ModelName_PrivateKeyPassphrase: 'Private key passphrase',
    ModelName_WriteBatchTimeout: 'Write batch timeout',
    Dataset_PreScript_Label: 'Pre-copy script',
    ModelName_PackageStore: 'Model of Package store',
    ModelName_PackageStores: 'Model of Package stores',
    ModelName_PackageStoreName: 'Package Store Name',
    ModelName_PackageStoreLinkedService: 'Package Store Linked Service',
    FileShare_DisplayText: 'File share',
    KeyStoreAuthType: 'Key store authentication type',
    AlwaysEncrypted: 'Always encrypted',
    ModelName_BaseUrl: 'Base URL',
    ModelName_AKVLinedService: 'AKV linked service',
    ModelName_SecretName: 'Secret name',
    ModelName_SecretVersion: 'Secret version',
    ModelName_StorageAccountName: 'Storage account name',
    ModelName_StorageAccountKey: 'Storage account key',
    ModelName_EndpointSuffix: 'Endpoint suffix',
    ModelName_PrimaryEndpoint: 'Partitioned DNS endpoint',
    enablePartitionedDns: 'Partioned DNS enabled',
    ModelName_SasURI: 'Storage SAS URI',
    ModelName_SasToken: 'SAS token',
    ModelName_Tenant: 'Tenant',
    ModelName_ServicePrincipalID: 'Service principal ID',
    ModelName_ServicePrincipalKey: 'Service principal key',
    ServicePrincipalFICSubpath: 'Service principal Federated Managed Identity (FMI) subpath',
    ServicePrincipalAuthority: 'Service principal authority',
    ModelName_Url: 'URL',
    ModelName_ServerName: 'Server name',
    ModelName_DatabaseName: 'Database name',
    ModelName_SqlPoolName: 'SQL pool name',
    ModelName_UserName: 'User name',
    ModelName_Language: 'Language',
    ModelName_Password: 'Password',
    ModelName_CatalogServicePath: 'Catalog service path',
    ModelName_ClientId: 'Client ID',
    ModelName_PowerBIWorkspaceID: 'Power BI Workspace',
    ModelName_DatasetTemplate: '{0} dataset',
    ModelName_DatasetsTemplate: '{0} datasets',
    ModelName_AuthenticationKind: 'Authentication kind',
    ModelName_AuthenticationType: 'Authentication type',
    ModelName_Endpoint: 'Endpoint',
    ModelName_DataSourcePath: 'Data source path',
    SQLConnectionString: 'SQL connection string',
    ModelName_AzureCloudType: 'Azure cloud type',
    AmazonS3_DisplayText: 'Amazon S3',
    AzureBlobFS_DisplayText: 'Azure Data Lake Storage Gen2',
    Lakehouse_DisplayText: 'Lakehouse',
    WorkspaceDetails: 'Workspace details',
    WorkspaceId: 'Workspace ID',
    ArtifactId: 'Artifact ID',
    ModelName_ServicePrincipalCredentialType: 'Service principal credential type',
    ModelName_ServicePrincipalCert: 'Service principal certificate',
    ModelName_UamiResourceID: 'User Assigned Managed Identity resource ID',
    Credential: 'Credential',
    Credentials: 'Credentials',
    ServicePrincipal: 'ServicePrincipal',
    GlobalParameter: `Global parameter`,
    GlobalParametersLabel: `Global parameters`,
    DataFactory: `Data Factory`,
    DataFactories: `Data Factories`,
    FactoryGlobalParameterValueError: `Global Parameter with the name {0} is missing required property value.`,
    ModelName_RetryPolicy: `Retry policy`,
    ModelName_RetryCount: `Retry policy: count`,
    ModelName_RetryInterval: `Retry policy: interval in seconds`,
    Trigger_ParameterValueRequired: `Parameter \'{0}\' has no default value, must be specified`,
    Trigger_Parameterization_ValidIntegerErrorMessage: `Parameter \'{0}\' should be a valid integer`,
    Trigger_Parameterization_ValidFloatErrorMessage: `Parameter \'{0}\' should be a valid float`,
    Trigger_Parameterization_ValidBooleanErrorMessage: `Parameter \'{0}\' should be a valid boolean`,
    Trigger_Parameterization_ValidArrayErrorMessage: `Parameter \'{0}\' should be a valid array`,
    ModelName_RecurrenceSchedule: `Recurrence schedule`,
    ModelName_Minutes: `Minutes`,
    ModelName_Hours: `Hours`,
    ModelName_Weekdays: `Weekdays`,
    ModelName_MonthDays: `Month days`,
    ModelName_MonthlyOccurences: `Monthly occurences`,
    ModelName_RecurrenceScheduleOccurence: `Recurrence schedule occurence`,
    ModelName_Day: `Day`,
    ModelName_Occurence: `Occurence`,
    Trigger_Event: `Event`,
    ModelName_EventTriggers: `Event triggers`,
    ModelName_Scope: `Storage account`,
    ModelName_BlobPathBeginsWith: `Blob path begins with`,
    ModelName_BlobPathEndsWith: `Blob path ends with`,
    Trigger_IgnoreEmptyBlobs: `Ignore empty blobs`,
    ModelName_MaxConcurrency: `Max concurrency`,
    Trigger_CustomEvents: `Custom events`,
    ModelName_AdvancedFilters: `Advanced filters`,
    ModelName_StorageEvents: 'Storage events',
    ModelName_StorageEventTriggers: 'Storage event triggers',
    ModelName_CustomEventsTrigger: `Custom event trigger`,
    ModelName_CustomEventsTriggers: `Custom event triggers`,
    ModelName_ScopeLabel: `Scope`,
    ModelName_SubjectBeginsWith: `Subject begins with`,
    ModelName_SubjectEndsWith: `Subject ends with`,
    EventTriggerValidationMessage: `Blob events trigger requires a blob path input.`,
    Trigger_EventInvalidScopeFormat: `Invalid scope format, the storage account name must be in lowercase and the scope must be written in the format: /subscriptions/{subscriptionId}/resourceGroups/{resourceGroupName}/providers/Microsoft.Storage/storageAccounts/{storageaccountname}`,
    ModelName_ChainingTrigger: `Chaining`,
    ModelName_ChainingTriggers: `Chaining triggers`,
    Trigger_Chaining_DependentPipelines: `Dependent pipelines`,
    RunDimensionLabel: `Run Dimension`,
    ModelName_ServicePrincipalCredentialProperties: 'Service Principal Credential Properties',
    ModelName_FederatedIdentityCredentialProperties: 'Federated Identitiy Credential Properties',
    ModelName_UserAssignedManagedIdentityCredentialProperties: 'User Assigned Managed Identity Credential Properties',
    ModelName_UserAuthCredentialProperties: 'User Auth Credential Properties',
    AzureSQLManagedInstance_DisplayText: 'Azure SQL Database Managed Instance',
    Error_InvalidAKVLSReferenced: 'Cannot reference to an invalid or deleted Azure Key Vault Linked Service.',
    Error_InvalidCredentialReferenced: 'Cannot reference to an invalid or deleted Credential object.',
    Error_InvalidLinkedServiceReferenced: '{0} cannot reference to an invalid or deleted {1}.',
    SubscriptionId: 'Subscription ID',
    ResourceGroup: 'Resource group',
    CognitiveService_DisplayText: 'Azure Cognitive Service',
    ModelName_CognitiveServiceName: 'Azure Cognitive Service name',
    ModelName_CognitiveServiceKind: 'Azure Cognitive Service kind',
    ModelName_CognitiveServiceLocation: 'Azure Cognitive Service location',
    ModelName_CognitiveServiceEndpoint: 'Azure Cognitive Service endpoint',
    ModelName_CognitiveServiceKey: 'Azure Cognitive Service key',
    Validator_NamePattern_StartEnd_Alphanumeric: '{0} name should start and end with letter or number.',
    Validator_NamePattern_All_AlphanumericUnderscore: '{0} name should only contain letters, numbers or underscores (_).',
    Validator_NamePattern_All_AlphanumericUnderscoreSpace: '{0} name should only contain letters, numbers, underscores (_), or spaces.',
    Validator_NamePattern_Start_AlphanumericUnderscore: '{0} name should start with letter, number or underscore (_).',
    Validator_NamePattern_StartEnd_AlphanumericUnderscore: '{0} name should start and end with letter, number or underscore (_).',
    Validator_NamePattern_All_AlphanumericUnderscoreDashSpace: '{0} name should only contain letters, numbers, dashes (-), underscores (_), or spaces.',
    Validator_NamePattern_No_TrailingSpace: '{0} name should not have trailing space.',
    Validator_NameMaxLength: '{0} name has exceeded the limit of {1}.',
    Validator_NameMinLength: '{0} name should contain at least {1} characters.',
    Validator_NameRequired: '{0} name is required.',
    Validator_HourRange: 'Hour value not in range 0-23',
    Validator_MinSecRange: 'Minute or second value not in range 0-59',
    Validator_ExceedDayLimit: 'Maximum amount of time cannot exceeds 7 days.',
    Validator_Database_Name_Blocked_Git: 'master, model, tempdb, msdb, distributor are reserved and not allowed as database names',
    Validator_Column_NameRequired: 'A column name is required in {0}(Table).',
    Validator_Column_TypeRequired: 'A column data type is required in {0}(Table).',
    Validator_Column_AlreadyExist: 'A column with the same name already exists in the {0}(Table).',
    Validator_Column_DecimalFormatError: 'Precision and scale values should only contain whole numbers and commas (,) in the form 18,2 in {0}(Table).',
    Validator_Column_StringLengthError: 'Length value is required in {0}(Table).',
    Validator_Column_MaxStringLengthError: 'Maximum length value for datatype string is {0}. Choose a smaller length value',
    Validator_Relationship_ColumnNameRequired: 'A column name is required in a relationship for {0}(Table).',
    Validator_Relationship_TableNameRequired: 'A table name is required in a relationship for {0}(Table).',
    Validator_Relationship_AlreadyExist: 'A relationship between tables {0} and {1} already exists on columns {2} and {3}. To create a relationship, choose a different table name or column name.',
    Validator_Relationship_DatatypeMisMatch: 'Datatype mismatch between {0} in {1}(Table) and {2} in {3}(Table). To create a relationship, choose columns of the same datatype.',
    Validator_Table_NameNotUnique: 'A table with the same name already exists in the database.',
    Validator_Table_StorageLocationIncorrect: 'Table {0} has incorrect storage account location. Linked service may need to be reselected',
    Validator_AirflowEntity_ValidSubtypeRequired: 'A valid Airflow Entity subtype is required',
    Validator_MinTimeout: 'Timeout must be greater than 10 minutes',
    ExponentialRetryValidationError: 'Maximum retry interval must be greater than the minimum retry interval when using increasing delay',

    ManagedResources: 'Managed resources',

    LinkTopicSourceTargetTablesUniqueValidationError: '{0} table name {1} is duplicated in link connection {2}',
    Source: 'Source',
    Target: 'Target',

    ApacheSparkConfiguration: 'Apache Spark configuration',
    ApacheSparkConfigurations: 'Apache Spark configurations',

    MappingArtifact: 'Mapping Artifact',
    MappingArtifacts: 'Mapping Artifacts',
    InvalidMappingType: 'Invalid mapping type',
    InvalidSourceColumn: 'Invalid source column',
    InvalidTargetColumn: 'Invalid target column',
    InvalidMappings: 'Invalid mappings',

    AzureSynapseAnalyticsArtifacts: 'Azure Synapse Analytics (Artifacts)',
    Authentication: 'Authentication',
    ModelName_SynapseWorkspaceEndpoint: 'Azure Synapse Analytics workspace URL',
    ModelName_WorkspaceResourceId: 'Workspace resource ID',

    DataTypePrecision: 'Precision',
    DataTypeScale: 'Scale',
    DataTypeFormat: 'Format',
    ValidatorErrorMessageTimestamp: 'Invalid timestamp format. This will comvert all input timestamp values into \'{0}\'',
    ValidatorErrorMessageDecimal: 'Invalid {0} value. {1} value should be between {2} and {3}',

    EventHubs_DisplayText: 'Event Hubs',
    ModelName_EventHubs_Namespace_DisplayText: 'Event Hubs namespace',
    ModelName_EventHubs_PolicyName_DisplayText: 'Event Hubs policy name',
    ModelName_EventHubs_PolicyKey_DisplayText: 'Event Hubs policy key',

    PipelineParameter: 'Pipeline parameter',

    Snowflake_Oauth_Disabled_Error: 'OAuth authentication is disabled.',
    ImportSettings_Label: 'Import settings',
    ExportSettings_Label: 'Export settings',
    ImportOrExportSettings_Label: 'Import or export settings',
    Additional_CopyOptions_Label: 'Additional {0} copy options',
    Additional_FormatOptions_Label: 'Additional {0} format options',
    StorageIntegration_Label: 'Storage integration',

    CopyJobIdLabel: 'Copy job ID',
    CopyJobLabel: 'Copy job',

    SqlEndpointLabel: 'SQL endpoint',
    SqlEndpointIdLabel: 'SQL analytics endpoint',

    DataBuildToolJobIdLabel: 'DataBuildTool job ID',
    DataBuildToolJobLabel: 'DataBuildTool job',

    DataQualityIdLabel: 'Data Quality item ID',
    DataQualityLabel: 'Data Quality',

    FabricWebLabel: 'Fabric Web',

    GenericWebLabel: 'Generic Web',

    Approval: 'Approval',
    ApproverLabel: 'Approver',
    RequestLabel: 'Request',

    MicrosoftTeamsIdLabel: 'Microsoft Teams',
    PostIn: 'Post in',
    GroupChat: 'Group chat',
    Team: 'Team',
    Channel: 'Channel',
    Message: 'Message',
    Subject: 'Subject',
    TeamsActivityConnectionToolTip: 'Reference to the team connection for authentication purpose.',

    Office365Email_Label: 'Office 365 Email',
    Body_Label: 'Body',
    To_Label: 'To',
    From_Send_As_Label: 'From (send as)',
    CC_Label: 'Cc',
    BCC_Label: 'Bcc',
    Sensitivity_Label: 'Sensitivity',
    Reply_To_Label: 'Reply to',
    Importance_Label: 'Importance',
    OnBehalfOfUser_Label: 'On behalf of user',

    Custom_Endpoint: 'Custom Endpoint',
    Outlook365: 'Outlook 365',
    
    EnforceOneTimeExecution: 'Enforce one-time execution',

    FtpServer_DisplayText: 'FTP',
    ModelName_Port: 'Port',
    ModelName_EnableSSL: 'Secure Transmission',
    ModelName_EnableServerCertificateValidation: 'Server certificate validation',
    Hdfs_DisplayText: 'HDFS',
    ModelName_HdfsClusterUri: 'Cluster URL',
    Sftp_DisplayText: 'SFTP',
    ModelName_SkipHostKeyValidation: 'SSH host key validation',
    ModelName_HostKeyFingerprint: 'SSH host key fingerprint',
    ModelName_PrivateKeyPath: 'Private key path',
    ModelName_PrivateKeyContent: 'Private key content',
    ModelName_PassPhrase: 'Passphrase',
    SFTP_PublicKeyPath_AzureIR_Error: 'Public key path is not allowed when using Azure integration runtime.',
    ModelName_MultiLineRow: 'Multiline rows',
    AuthKind_Basic: 'Basic',
    AuthKind_Key: 'Key',
    AuthKind_OrganizationalAccount: 'Organizational account',
    AuthKind_ServicePrincipal: 'Service principal',
    AuthKind_WorkspaceIdentity: 'Workspace identity',
    AuthKind_Anonymous: 'Anonymous',
    ModelName_AccessKeyID: 'Access key ID',
    ModelName_SecretAccessKey: 'Secret access key',
    ModelName_ServiceUrl: 'Service URL',
    ModelName_SessionToken: 'Session token',
    ModelName_BucketName: 'Bucket name',
};
